/**
 * announcement Module
 *
 */

angular
  .module('announcements', ['ngResource', 'settings', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.announcements.all(), {
        controller: 'AnnouncementCtrl',
        templateUrl: '/r/static/templates/announcements/list.html',
      })
      .when(CONFIG.url.announcements.create(), {
        controller: 'AnnouncementAddCtrl',
        templateUrl: '/r/static/templates/announcements/new.html',
      })
      .when(CONFIG.url.announcements.view(), {
        controller: 'AnnouncementEditCtrl',
        templateUrl: '/r/static/templates/announcements/single.html',
      })
  }])

  .factory('Announcement', ['$resource', function ($resource) {
    var Announcement = $resource(
      CONFIG.api('announcements'),
      {},
      {
        query: {method: 'GET', isArray: false},
        supersearch: {method: 'POST', isArray: false, params: {id: 'supersearch'}},
        preview: {method: 'POST', params: {id: 'preview'}},
      },
    )
    return Announcement
  }])

/* Controllers */

angular
  .module('announcements')
  .controller('AnnouncementCtrl', ['$scope', '$location', '$timeout', '$rootScope', 'Announcement', '$compile', function ($scope, $location, $timeout, $rootScope, Announcement, $compile) {
    if ($location.path() == CONFIG.url.announcements.all()) {
      $scope.utils.setPageTitle(_('announcement_sent_announcements'))
      $scope.utils.setPageID('announcements')
    }

    getAnnouncements()

    $scope.paginate = function (page) {
      $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
    }

    // NB: Almost duplicate in invoice.js / membercards.js
    if ($location.hash().match(/receipt-notify\?n=(\d+)/)) {
      $rootScope.notification = $compile(
        '<span>' +
          _('HTML_notification_mooney_announcement_sent_paid', {
            _n: RegExp.$1,
            url: CONFIG.url.log.receipts(),
          }) +
          '</span>',
      )($scope)
    }

    function getAnnouncements() {
      Announcement.query(
        {
          id: 'all',
          dashboard: $location.path() !== CONFIG.url.announcements.all(),
        },
        // success handler
        function (data) {
          $scope.announcements = data.announcements
          $scope.stats = data.stats

          $rootScope.announcement_dashboard_ok = true

          // pagination
          $scope.pageSize = 20
          $scope.numberOfPages = Math.ceil($scope.announcements.length / $scope.pageSize)
          $scope.currentPage = 0

          a4.loaded($scope)

          var refresh = false
          // $.each($scope.announcements, function(i, a) {
          //   a.stats.sent_percentage = Math.floor(100 * (a.stats.total - a.stats.count_queued) / a.stats.total);
          //   if(a.stats.count_queued > 0) {
          //     refresh = true;
          //   }
          // });

          if (refresh && $location.path() == CONFIG.url.announcements.all()) {
            a4.timeout($timeout, $scope, getAnnouncements, 5000)
          }
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }
  }])

angular
  .module('announcements')
  .controller(
    'AnnouncementAddCtrl',
    ['$rootScope', '$scope', '$location', '$compile', 'Announcement', 'Settings', '$timeout', function ($rootScope, $scope, $location, $compile, Announcement, Settings, $timeout) {
      a4.checkStrongholdNotification($rootScope, $scope, $location, $compile)

      $scope.utils.setPageTitle(_('announcement_create_new_announcement'))
      $scope.utils.setPageID('announcements')

      $scope._sending = false
      $scope.previewing = false

      $scope.current_media = 'email'

      $scope.pages = [{num: 1, content: ''}]

      $scope.add_page = function () {
        if ($scope.pages.length < 16) {
          $scope.pages.push({
            num: $scope.pages.length + 1,
            content: '',
          })
        }
      }

      $scope.remove_page = function () {
        if ($scope.pages[$scope.pages.length - 1].content === '' || confirm(_('js_page_remove_confirm'))) {
          $scope.pages.pop()
        }
      }

      // https://stackoverflow.com/questions/822452/strip-html-from-text-javascript
      $scope.strip_html = function (html) {
        let tmp = document.createElement('div')
        tmp.innerHTML = html
        return tmp.textContent || tmp.innerText || ''
      }

      Settings.get({}, function (settings) {
        $scope.settings = settings

        $scope.$watch('msg.content+msg.msg_media', function () {
          // get rid of the letter separator if the user decides to switch to e.g. sms all of a sudden
          if (
            $scope.msg &&
            $scope.msg.msg_media !== 'letter' &&
            $scope.msg.content &&
            $scope.msg.content.indexOf(a4.letterPageSeparator()) !== -1
          ) {
            $scope.msg.content = a4.stripLetterPageSeparator($scope.msg.content)
          }
          ////////// common sms stuff --------->
          // calculate the number of characters and estimated number of sms msgs
          if ($scope.msg && $scope.msg.msg_media === 'sms') {
            var max_parts = $scope.settings.sms_.max_number_of_messages
            var max_chars = $scope.settings.sms_.max_chars_per_message
            var sms_length = a4.trimSmsContent($scope.msg.content).length
            $scope.sms_parts = Math.ceil(sms_length / max_chars)
            $scope.sms_percentage = (sms_length / (max_parts * max_chars)) * 100
            if ($scope.sms_parts < 2) {
              $scope.sms_type = 'single'
            } else if ($scope.sms_parts <= max_parts) {
              $scope.sms_type = 'multi'
            } else {
              $scope.sms_type = 'too_long'
            }
          }
          ///////////// <------- common sms stuff
        })
      })

      $scope.msg = new Announcement({
        subject: '', // "Title",
        content: '', // "Description text.",
        msg_media: $scope.current_media,
      })
      // TMP for testing -->
      //$scope.msg.msg_media = 'sms';
      //$scope.msg.content = 'Foo ca. 140 chars, jviarhiouv hoaöhua eiluvhgiu dfhviu ahlisvh iluaehrliuv hdluifhv ialuhviu hsiublvha iluvhbiudl hbviluarh viohjiov harjilu';
      // <-- TMP
      a4.loaded($scope)

      $scope.proceed_to_payment = function () {
        var _self = this

        $scope.msg.filter = $scope.filter_to_post

        $scope._sending = true

        Announcement.save(
          {},
          $scope.msg,
          // success handler
          function (data) {
            _self.announcement_form.$dirty = false
            $location.path(CONFIG.url.mooney.method(data['mid'])).search('goto', CONFIG.get('urls.announcements.all'))
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }

      $scope.msgModel = function () {
        return 'announcement'
      }

      $scope.preview = a4.msgPreview($scope, Announcement)
      $scope.cancelPreview = a4.msgPreviewCancel($scope)

      // NB: Identical to the one in invoice.js
      $scope.filterInvalidMembers = function (context) {
        return function (member) {
          if (!$scope.stats) {
            return false
          }
          var invalidIds = $scope.stats['result_' + context + '_invalid_ids'] || []
          return invalidIds.includes(member.id)
        }
      }

      // NB: This is found on announcements + invoices + updreqs
      $scope.$watch('settings+msg.msg_media', function () {
        if ($scope.settings) {
          $scope.emailMissing = $scope.msg.msg_media === 'email' && $scope.settings.email_missing_
          $scope.vatIdRequired = $scope.msg.msg_media === 'letter' && $scope.settings.vat_id_missing_
          $scope.bankAccountRequired = false
        }

        if ($scope.msg.msg_media != $scope.current_media) {
          let change_current_media = true
          if ($scope.msg.content != '') {
            if ($scope.msg.msg_media == 'sms') {
              if (confirm(_('js_confirm_msg_media_change'))) {
                $scope.msg.content = $scope.strip_html($scope.msg.content)
              } else {
                // cancel: revert back to previous media type
                change_current_media = false
                // radio doesn't update correctly without the timeout
                $timeout(function () {
                  $scope.msg.msg_media = $scope.current_media
                }, 1)
              }
            }
          }
          if (change_current_media) {
            $scope.current_media = $scope.msg.msg_media
          }
        }

        // Do some dirty polling to initialize ckeditor when the textarea is in DOM
        if ($scope.msg.msg_media == 'email') {
          const id = setInterval(() => {
            const tiptapContainer = document.querySelector('.tiptap-container')

            if (tiptapContainer) {
              clearInterval(id)
              if (!window.initTiptap) {
                alert(_('announcement_browser_not_supported'))
                location.href = '/r/'
              }

              var tiptapLang = $rootScope.session.user.lang
              if (!['fi', 'en', 'sv'].includes(tiptapLang)) {
                tiptapLang = 'fi'
              }

              window.initTiptap(tiptapContainer, {
                language: tiptapLang,
                disabled: tiptapContainer.classList.contains('tiptap-container--disabled'),
                onInput: (modelValue) => {
                  // When data changes, set it to $scope. If there is a (new) relative link,
                  // convert it to absolute and update the model.
                  if (/href="[\/#]/.test(modelValue.value)) {
                    const base = location.href.replace(/\/r\/.*/, '')
                    modelValue.value = modelValue.value.replace(/href="([\/#])/, `href="${base}$1`)
                  }

                  $scope.msg.content = modelValue.value
                },
              })
            }
          }, 300)
        }
      })
    }],
  )

angular
  .module('announcements')
  .controller('AnnouncementEditCtrl', ['$scope', '$routeParams', '$timeout', 'Announcement', function ($scope, $routeParams, $timeout, Announcement) {
    $scope.utils.setPageID('announcements')
    $scope.viewStatus = ''

    getAnnouncement()

    function getAnnouncement() {
      Announcement.get(
        {id: $routeParams.id},
        // success handler
        function (data) {
          $scope.msg = data
          $scope.pages = $scope.msg.content.split(a4.letterPageSeparator())
          $scope.utils.setPageTitle(data.subject)
          if ($scope.msg.msg_media == 'email') {
            // mark all the members that have one or more bounce messages
            // so that we can show only them in the list
            $scope.msg.msgs.forEach((m) => {
              if (m.msg_statuses.some((s) => s.status === 'bounced')) {
                m.status = 'error'
              }
            })
            $scope.msg.count_error = $scope.msg.msgs.filter((m) => m.status === 'error').length
          }
          a4.loaded($scope)
        },
        a4.restErrorFactory($scope),
      )
    }

    $scope.toggleViewStatus = function () {
      $scope.viewStatus = $scope.viewStatus === '' ? 'error' : ''
    }
    $scope.filterCombinedStatus = function (thing) {
      return $scope.viewStatus === '' ? true : thing.status == $scope.viewStatus
    }
  }])
